(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
     
(function() {
  var progressBar = document.getElementById('readingProgress');
  if (progressBar) {
    var contentStart = document.querySelector('.blog-index-container');
    var contentEnd = document.querySelector('.tags--article') || document.querySelector('.related-articles') || document.querySelector('#comments') || document.querySelector('.return-link');
    var startOffset = 0;
    var endOffset = 0;
    var containerHeight = 0;
    var hideTimeout;
    
    if (contentStart) {
      startOffset = contentStart.offsetTop;
      containerHeight = contentStart.offsetHeight;
    }
    
    if (contentEnd) {
      endOffset = contentEnd.offsetTop;
    } else {
      endOffset = document.documentElement.scrollHeight;
    }
    
    function updateProgress() {
      var windowHeight = window.innerHeight;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var containerBottom = startOffset + containerHeight;
      
      if (scrollTop > containerBottom) {
        progressBar.classList.add('visible');
      } else {
        progressBar.classList.remove('visible');
      }
      
      var contentHeight = endOffset - startOffset;
      var adjustedScrollTop = scrollTop - startOffset;
      var trackableHeight = endOffset - startOffset - windowHeight;
      
      if (trackableHeight <= 0) {
        trackableHeight = contentHeight;
      }
      
      var scrollPercentage = adjustedScrollTop / trackableHeight;
      scrollPercentage = Math.min(1, Math.max(0, scrollPercentage));
      
      progressBar.style.transform = 'scaleY(' + scrollPercentage + ')';
      
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(function() {
        progressBar.classList.remove('visible');
      }, 1000);
    }
    
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateProgress();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    updateProgress();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
